
<template>
	<div style="width:100%;background-color:#F9F9FB">
		<div class="detailPage" v-if="detailInfo.comicName">
			<div class="detail detailPage-kuang">
				<div class="detail-img">
					<img  @dragstart.prevent  :src="detailInfo.realCoverUrl" alt="">
				</div>
				<div class="detail-info">
					<div class="detail-info-top">
						<div class="detail-info-top-tit">{{detailInfo.comicName}}</div>
						<div class="detail-info-top-right flex-row-center">
							<div class="flex-row-center" style="margin-right: 40px;">
								<!-- <img  @dragstart.prevent  src="../assets/icon_detail_dianzan.png" class="icon" alt="" /> -->
								<img  @dragstart.prevent  src="../assets/icon_detail_yidianzan.png" class="icon" alt="" />
								<span>{{detailInfo.likeNumSum}}</span>
							</div>
							<div class="flex-row-center">
								<img  @dragstart.prevent  src="../assets/icon_detail_redu.png" class="icon" alt="" />
								<span>{{detailInfo.enjoyNum + detailInfo.defaultEnjoyNum}}</span>
							</div>
						</div>
					</div>
					<div class="detail-info-author">作者：{{detailInfo.author}}</div>
					<p class="detail-info-mid txtOverFlow2">{{detailInfo.introduction}}</p>
					<div class="detail-info-bot">
						<div class="detail-info-bot-watch cursorPointer" @click="handleToConent(detailInfo.currentChapterId, detailInfo.comicId, detailInfo.currentUnlockType)">{{detailInfo.currentChapterNumber != 1 ? '继续观看第'+detailInfo.currentChapterNumber : '观看第1'}}话</div>
						<div class="detail-info-bot-keep cursorPointer" @click="handleCollect">
							<img  @dragstart.prevent  v-show="detailInfo.enjoyStatus == 0 || !detailInfo.enjoyStatus" src="../assets/icon_detail_shoucang.png" class="icon" alt="" />
							<img  @dragstart.prevent  v-show="detailInfo.enjoyStatus == 1" src="../assets/icon_detail_yishoucang.png" class="icon" alt="" />
							<span style="padding-top: 1px;">{{detailInfo.enjoyStatus == 1 ? '已':''}}收藏</span>
						</div>
					</div>
				</div>
			</div>

			<div class="listAndRecommend">
				<div class="list detailPage-kuang">
					<div class="list-titBox">
						<div class="flex-row-center">
							<div class="list-titBox-tit">章节列表</div>
							<div class="list-titBox-dec">
								<span v-show="detailInfo.comicStatus == 0">连载中</span>
								<span v-show="detailInfo.comicStatus == 1">完结</span>
								 | <span>共{{detailInfo.totalNum}}话</span>
							</div>
						</div>
						<div class="list-titBox-tag flex-row-center">
							<div v-if="detailInfo.cone">{{detailInfo.cone}}</div>
							<div v-if="detailInfo.ctwo">{{detailInfo.ctwo}}</div>
							<div v-if="detailInfo.cthree">{{detailInfo.cthree}}</div>
						</div>
					</div>
					<div class="list-menu1">
						<div :class="[index == selected ? 'list-menu1-item list-menu1-item-act' : 'list-menu1-item']" 
							v-for="(item,index) in detailList.blockList" :key="'juji'+index"  @click="getChapterList(index,detailInfo.comicId)"
						>
							<span>{{item}}</span>
						</div>
					</div>
					<div class="list-menu2">
						<div class="list-menu2-item cursorPointer" v-for="(item,index) in detailList.comicChapterShowVOList" :key="'juji'+index" @click="handleToConent(item.chapterId,item.comicId,item.unlockType)">
							<div class="ooimg">
								<img  @dragstart.prevent  :src="detailInfo.realCoverUrl" class="icon" alt="" />
								<div class="suo flex-center" v-if="item.unlockType == 0">
									<img  @dragstart.prevent  src="../assets/icon_suo@2x.png" alt="">
								</div>
							</div>
							<div class="list-menu2-item-right">
								<span class="list-menu2-item-right-tit txtOverFlow1">{{item.chapterName}}</span>
								<span class="list-menu2-item-right-dec">第{{item.chapterNumber}}话</span>
							</div>
							
						</div>
					</div>
				</div>
				<div class="recommend detailPage-kuang">
					<div class="recommend-tit">作品推荐</div>
					<div class="recommend-list">
						<div class="recommend-list-item cursorPointer" v-for="(item,index) in recommendList" :key="'tuijian'+index" @click="handlerecom(item.comicId)"><!--getInit(item.comicId)-->
							<img  @dragstart.prevent   v-if="index<3" :src="item.realCoverUrl" class="icon" alt="" />
							<p v-if="index<3" >{{item.comicName}}</p>
						</div>
					</div>
				</div>
			</div>
			<buy-info-mode 
				v-if="isShowBuyInfoMode" 
				:singlePrice="detailList.singlePrice" 
				:buyInfoType="buyInfoType" 
				:userMoney="userMoney" 
				:checkAutoSub="checkAutoSub"
				@changeCheckAutoSub="changeCheckAutoSub"
				@handleBtn="handleBtn" 
				@closeBuyInfoMode="closeBuyInfoMode"
			></buy-info-mode>
			<payModel v-if="isshowPayModel" :pay-list="payList" @closePayModel="()=>{isshowPayModel = false}" @modelPay="modelPay" :userMoney="userMoney"></payModel>
			<!-- 提示 -->
			<model-to-login v-if="isShowLoginModel" :errMsg="errMsg" @closeLoginModel="()=>{isShowLoginModel = false}"></model-to-login>
		</div>
	</div>
</template>
<script type="text/javascript">
	import router from '../router/index'
	import {comicuserChapterList,comicuserComicDetail, homeRecommend , enjoyReadPoint,enjoyReadCancelPoint,rechargeRemain,gearGet,unlockChapter, switchAutoSub} from '@/utils/api'
	import { navTo,navToDetail, getUserInfo, refreshUserInfo, payMoneyPublic} from '../utils/utils'
	import payModel from "../components/payModel.vue"
	import modelToLogin from "../components/modelToLogin.vue"
	import buyInfoMode from "../components/buyInfoMode.vue"
	export default {
		props:['loginstatus'],
		data(){
			return{
				selected:0,
				detailList:{currentChapterNumber:0,singlePrice:0},
				detailInfo:{},
				recommendList:[],
				isShowLoginModel:false,
				checkAutoSub:true,// 自动订阅单选项
				isShowBuyInfoMode:false,
				userMoney:0,
				buyInfoType:0,
				actChapterId:0,
				isshowPayModel:false,
				payList:[],
				errMsg:'',
			}
		},
		components:{
			payModel,
			modelToLogin,
			buyInfoMode
		},
		watch:{
			$route: {
				handler: function(val, oldVal){
					this.getInit(val.query.id)
				},
				// 深度观察监听
				deep: true
			}
		},
		mounted(){
			// 获取漫画详情
			this.getInit(router.currentRoute.value.query.id)
		},
		unmounted(){
		},
		methods:{
			handlerecom(id){
				navTo('/detail',{id:id})
			},
			getInit(comicId){
				this.detailInfo = {comicName:''}
				comicuserComicDetail({comicId}).then(res=>{
					this.detailInfo = res.data
				})
				this.getChapterList(0,comicId)
				// 获取右侧推荐漫画
				homeRecommend({comicId}).then(res=>{
					this.recommendList = res.data
				})
				window.scrollTo(0, 0)
			},
			/** 获取章节目录 */
			getChapterList(index,comicId){
				this.selected = index
				comicuserChapterList({comicId, page: index+1}).then(res=>{
					this.detailList = res.data
				})
			},
			gotoLogin(){
				navTo('/login')
				localStorage.setItem('currPath',`/detail?id=${this.detailInfo.comicId}`)
			},
			// 点击某一章节
			handleToConent(chapterId, comicId, unlockType){
				let info = getUserInfo()
				this.actChapterId = chapterId
				if( unlockType != 1 ){
					if(!this.loginstatus){
						// 没登陆不能看付费章节
						this.gotoLogin()
					}else{
						if(info.vip){
							// vip不弹弹窗
							unlockChapter({chapterId:this.actChapterId}).then(res=>{
								if(res.code == 200){
									navTo("/comicContent",{chapterId:chapterId ,comicId:comicId})
								}else if(res.code == 2001){
									if(res.msg == '当前漫画已解锁，请勿重复解锁'){
										navTo("/comicContent",{chapterId:this.actChapterId ,comicId:this.detailInfo.comicId})
									}else{
										this.isShowLoginModel = true
										this.errMsg = res.msg
									}
								}
							}).catch(res=>{
								if(res.code == 2001){
									if(res.msg == '当前漫画已解锁，请勿重复解锁'){
										navTo("/comicContent",{chapterId:this.actChapterId ,comicId:this.detailInfo.comicId})
									}else{
										this.isShowLoginModel = true
										this.errMsg = res.msg
									}
								}
							})
						}else{
							// 非vip，弹窗
							rechargeRemain().then(res=>{
								this.userMoney = res.data.remain
								if(info.autoSub == 0){
									this.isShowBuyInfoMode = true
								}
								// 判断钱都不够
								if(Number(res.data.remain)-Number(this.detailList.singlePrice)>=0){//钱够
									this.buyInfoType = 1
									if(info.autoSub == 1){//开了自动订阅
										this.handleBtn()
									}else{
										this.isShowBuyInfoMode = true
									}
								}else{//钱不够
									this.buyInfoType = 2
									this.isShowBuyInfoMode = true
								}
							})
						}
					}
				}else{
					navTo("/comicContent",{chapterId:chapterId ,comicId:comicId})
				}
			},
			handleCollect(){
				if(!this.loginstatus){
					// 没登陆不能收藏
					this.gotoLogin()
				}
				let comicId = this.detailInfo.comicId
				if(this.detailInfo.enjoyStatus == 1){
					this.detailInfo.enjoyStatus = 0
					enjoyReadCancelPoint({comicId}).then(res=>{})
				}else{
					this.detailInfo.enjoyStatus = 1
					enjoyReadPoint({comicId}).then(res=>{})
				}
			},
			changeCheckAutoSub(){
				this.checkAutoSub = !this.checkAutoSub
			},
			handleBtn(obj,isDirectGo){
				let info = getUserInfo()
				if(this.buyInfoType == 1){
					//立即观看按钮
					unlockChapter({chapterId:this.actChapterId}).then(res=>{
						if(res.code == 200){
							if((this.checkAutoSub && info.autoSub==0) || !this.checkAutoSub && info.autoSub==1){
								// 用户改了自动订阅状态
								switchAutoSub().then(()=>{
									refreshUserInfo()
								})
							}
							navTo("/comicContent",{chapterId:this.actChapterId ,comicId:this.detailInfo.comicId})
						}else if(res.code == 2001){
							if(res.msg == '当前漫画已解锁，请勿重复解锁'){
								navTo("/comicContent",{chapterId:this.actChapterId ,comicId:this.detailInfo.comicId})
							}else{
								this.isShowLoginModel = true
								this.errMsg = res.msg
							}
						}
					}).catch(res=>{
						if(res.code == 2001){
							if(res.msg == '当前漫画已解锁，请勿重复解锁'){
								navTo("/comicContent",{chapterId:this.actChapterId ,comicId:this.detailInfo.comicId})
							}else{
								this.isShowLoginModel = true
								this.errMsg = res.msg
							}
						}
					})
				}else if(this.buyInfoType == 2 || obj.val == 2){
					//充值按钮
					gearGet().then(res=>{
    					this.payList= res.data
						this.isShowBuyInfoMode = false
						this.isshowPayModel = true
						localStorage.setItem('currPath',`/detail?id=${this.detailInfo.comicId}`)
					})
				}
			},
			closeBuyInfoMode(){
				this.isShowBuyInfoMode = false
				this.actChapterId = 0
			},
			modelPay({index}){
				payMoneyPublic(this.payList[index].id,`/detail?id=${this.detailInfo.comicId}`)
			},

		}
	}
</script>
<style lang="scss" scoped="scoped" type="text/css">
	.detailPage{
		width: 1188px;
    	margin: 0 auto;
		&-kuang{
			background: #FFFFFF;
			border-radius: 10px;
			padding: 20px;
		}
		.detail{
			margin-top: 40px;
			display: flex;
			position: relative;
			&-img{
				width: 360px;
				height: 204px;
				margin-right: 30px;
				img{
					width: 100%;
					height: 100%;
					border-radius: 8px;
				}
			}
			&-info{
				flex: 1;
				&-top{
					display: flex;
					justify-content: space-between;
					align-items: center;
					line-height: 24px;
					color: #333;
					font-size: 18px;
					&-tit{
						font-weight: bold;
						color: #000000;
					}
					img{
						width: 17px;
						height: 18px;
						margin-right: 3px;
					}
					&-right{
						margin-right: 64px;
					}
				}
				&-author{
					margin-top: 10px;
					font-size: 16px;
					color: #333333;
					line-height: 22px;
					font-weight: bold;
				}
				&-mid{
					margin-top: 30px;
					font-size: 14px;
					color: #666666;
					line-height: 28px;
				}
				&-bot{
					display: flex;
					align-items: center;
					font-size: 20px;
					line-height: 28px;
					position: absolute;
					bottom: 20px;
					&-watch{
						padding: 7px 18px;
						background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
						border-radius: 21px;
						color: #FFFFFF;
						margin-right: 20px;
					}
					&-keep{
						display: flex;
						align-items: center;
						padding: 5px 18px;
						border-radius: 28px;
						border: 2px solid #979797;
						color: #999999;
						box-sizing: border-box;
						img{
							width: 22px;
							height: 22px;
							margin-right: 6px;
						}
					}
				}
			}
		}
		.listAndRecommend{
			display: flex;
			margin-top: 30px;
			margin-bottom: 100px;
			.list{
				width: 63%;
				min-height: 400px;
				&-titBox>div{
					align-items: end;
				}
				&-titBox{
					display: flex;
					align-content: center;
					justify-content: space-between;
					&-tit{
						font-size: 28px;
						color: #333333;
						line-height: 40px;
						margin-right: 20px;
					}
					&-dec{
						font-size: 16px;
						color: #999999;
						line-height: 22px;
						margin-bottom: 2px;
					}
					&-tag{
						margin-bottom: 2px;
						div{
							background: #FFD000;
							border-radius: 4px;
							padding: 1px 14px;
							margin-left: 10px;
							font-size: 16px;
							color: #333333;
							line-height: 22px;
						}
					}
				}
				&-menu1{
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					margin-top: 30px;
					&-item{
						border-radius: 17px;
						border: 1px solid #D2D2D2;
						padding: 5px 20px;
						margin-right: 24px;
						margin-bottom: 20px;
						cursor: pointer;
						span{
							font-size: 14px;
							line-height: 20px;
							letter-spacing: 1px;
							color: #999999;
						}
						&-act{
							background-color: #CB2945;
							border: 1px solid #CB2945;
							span{
								color: #FFFFFF;
							}
						}
					}
				}
				&-menu2{
					margin-top: 20px;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					&-item{
						width: 30%;
						height: 80px;
						background: #FFFFFF;
						border-radius: 6px;
						border: 1px solid #D2D2D2;
						padding: 8px;
						margin-bottom: 20px;
						margin-right: 15px;
						display: flex;
						color: #999999;
						position: relative;
						img{
							width: 106px;
							height: 62px;
							border-radius: 5px;
						}
						&-right{
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							margin-left: 8px;
							&-tit{
								width: 100px;
								font-size: 14px;
								color: #333333;
							}
							&-dec{
								font-size: 14px;
								color: #999999;
								line-height: 20px;
							}
						}
						.ooimg{
							width: 90px;
							height: 62px;
							img{
								width: 90px;
								height: 62px;
							}
							.suo{
								position: absolute;
								top: 8px;
								left: 8;
								width: 90px;
								height: 62px;
								border-radius: 5px;
								background-color: rgba(0, 0, 0, 0.30);
								img{
									width: 24px;
									height: 24px;
								}
							}
						}
					}
					&-item:hover{
						box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
					}
				}
			}
			.recommend{
				margin-left: 30px;
    			height: 890px;
				&-tit{
					font-size: 28px;
					color: #333333;
					line-height: 40px;
					padding-bottom: 30px;
				}
				&-list{
					// overflow-y: scroll;
    				// height: 775px;
					&-item{
						margin-bottom: 30px;
						img{
							width: 360px;
							height: 204px;
							border-radius: 8px;
							margin-bottom: 10px;
						}
						p{
							font-size: 18px;
							color: #000000;
							line-height: 24px;
						}
					}
				}
			}
		}
	}

</style>
